export enum ProviderType {
  Msp = 0,
  Reseller = 1,
}
